import React, { Component } from 'react';
import Modal from '../../../components/modal';
import Article from './article';
import YoutubeVideo from './youtube-video';
// import RelatedArticle from './related-article';

class VideoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
    };
  }

  openModal = () => {
    const { clickAction } = this.props;
    clickAction({ data: { mediaType: this.props.mediaType, contentId: this.props.id, userId: this.props.uId } });
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  render() {
    const styles = {
      overlay: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
      },
      content: {
        bottom: 'auto',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        maxWidth: '900px',
        width: '100%',
        background: 'white',
      },
    };

    const relatedArticles = this.props.relatedContent.map(article => (
      <div className="mb-6 col-12 col-sm-6" key={article.title}>
        <Article
          {...article}
          title=""
          buttonText={article.title.length > 39 ? `${article.title.substring(0, 39)}...` : article.title}
          clickAction={this.props.clickAction}
          uId={this.props.uId}
        />
      </div>
    ));

    return (
      <React.Fragment>
        <Article {...this.props} clickAction={this.openModal} />
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          ariaHideApp={false}
          style={styles}
          className="video-modal"
        >
          <YoutubeVideo
            youtubeVideoTitle={this.props.meta}
            id={this.props.id}
          />
          <p className="article-summary-text">{this.props.summary}</p>
          <div className="video-related-articles row events">
            <div className="col-12">
              <h2>{this.props.relatedContentHeadingText}</h2>
            </div>
            {relatedArticles}
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

export default VideoModal;
